export const client = typeof window !== "undefined";
